import { MediaInfoDto } from '@sr/dto';

export const getMediaCityName = (option: MediaInfoDto) => {
  if (!option.city) return '';
  return option.city.name || String(option.city);
};

export const getMediaLabel = (option: MediaInfoDto | string) => {
  if (typeof option === 'string') return option;

  const cityName = getMediaCityName(option);
  return cityName ? `${option.name} (${cityName})` : option.name;
};
